import { LtiErrorCode } from '/imports/domain';
import { end, formatRoute, lit, type, url } from '/imports/modules/Routing';

export const ltiErrorRoute = url(lit('ltiError'), type('code', LtiErrorCode), end);

export const ltiErrorLink = formatRoute(ltiErrorRoute);
